import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ArtLanding from "@/pages/ArtLanding";
import Landing from "@/pages/Landing";
import ARPreview from "@/pages/ARPreview";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import Reservations from "@/pages/Reservations";
import Receipt from "@/pages/Receipt";
import Privacy from "@/pages/Privacy";
import { initAnalytics } from "@/lib/analytics";

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ArtLanding />} />
          <Route path="/shop" element={<Landing />} />
          <Route path="/ar" element={<ARPreview />} />
          <Route path="/checkout/success" element={<Success />} />
          <Route path="/checkout/cancel" element={<Cancel />} />
          <Route path="/reservations" element={<Reservations />} />
          <Route path="/r/:id" element={<Receipt />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
